import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "recompose";
import AuthModule from "modules/auth";
import PageTitle from "components/PageTitle";
import CategoryLink from "components/CategoryLink";
// import ROUTES from "config/routes";
import history from "services/history";
// import { userTypesCompanies } from "config/constants";

class SignUpCompanies extends Component {
  componentDidMount() {
    const slug = this.props.match.path.split("/").at(-1);
    this.props.signUpPagesSlug(slug);
  }
  componentWillUnmount() {
    this.props.reset();
  }

  handleSwitch = (pathname) => {
    history.push({ pathname });
  };

  render() {
    return (
      <div className="page-body">
        <PageTitle
          align="center"
          title={this.props.slugData?.content?.title}
          isBackButton={true}
        />

        <div className="content-container">
          <div className="container">
            <div className="row justify-content-center">
              {this.props.slugData?.content?.sections?.map(
                ({ title, url }, index) => {
                  return (
                    <div
                      className="col-12 col-lg-4 d-flex"
                      key={`${title}${url}`}
                    >
                      <CategoryLink onClick={() => this.handleSwitch(url)}>
                        <div className="section-title-md text-center category-title">
                          {title}
                        </div>
                      </CategoryLink>
                    </div>
                  );
                }
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default compose(
  connect(
    (state) => ({
      isFetching: state.auth.isFetching,
      isFetched: state.auth.isFetched,
      slugData: state.auth.slugData,
    }),
    {
      signUpPagesSlug: AuthModule.signUpPagesSlug,
      reset: AuthModule.reset,
    }
  )
)(SignUpCompanies);
